import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { addToCart } from "../utils/cartUtils";
import { toast } from "react-toastify";

export default function ItemsDetails() {
    const { id } = useParams();
    const [item, setItem] = useState(null);
    const [quantity, setQuantity] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log("Fetching product with id:", id);
        axios
            .get("https://laravel-api.petra-ms.com/api/products")
            .then((response) => {
                console.log("API Response:", response.data);
                if (response.data.success) {
                    const product = response.data.data.find(
                        (el) => el.id.toString() === id
                    );
                    console.log("Found Product:", product);
                    setItem(product);
                } else {
                    setError("API returned success: false");
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching product:", error);
                setError(error.message);
                setLoading(false);
            });
    }, [id]);

    const increaseQty = () => setQuantity((prev) => prev + 1);
    const decreaseQty = () => setQuantity((prev) => (prev > 0 ? prev - 1 : 0));

    const handleAddToCart = () => {
        if (quantity === 0) {
            toast.error("Please select a quantity!", {
                position: "top-right",
                autoClose: 2000,
            });
            return;
        }

        const cartItem = {
            id: item.id,
            name: item.product_name,
            price: item.product_price,
            image: `https://laravel-api.petra-ms.com/storage/app/public/${item.product_img}`,
            quantity: quantity, // إضافة الكمية المختارة
        };
        addToCart(cartItem);
        toast.success(`${item.product_name} added to cart!`, {
            position: "top-right",
            autoClose: 2000,
        });
        setQuantity(0); // إعادة تعيين الكمية بعد الإضافة
    };

    if (loading) {
        return <div className="p-6 text-center">Loading...</div>;
    }

    if (error) {
        return <div className="p-6 text-red-500">Error: {error}</div>;
    }

    if (!item) {
        return <div className="p-6 text-red-500">Item not found</div>;
    }

    return (
        <section className="my-[20px] p-6 max-w-xl mx-auto bg-white rounded-lg shadow-md">
            <div className="relative h-[350px]">
                <img
                    src={`https://laravel-api.petra-ms.com/storage/app/public/${item.product_img}`}
                    alt={item.product_name}
                    className="rounded-lg w-full h-full object-cover"
                    onError={(e) => console.log(`Failed to load image: ${e.target.src}`)}
                />
            </div>
            <div className="mt-6 flex justify-between items-center">
                <h2 className="text-xl font-semibold">{item.product_name}</h2>
                <span className="text-sm text-gray-500">{item.product_availability}</span>
            </div>
            <p className="text-gray-500 mt-2">{item.product_description}</p>
            <div className="text-gray-500 mt-2 font-bold">
                {item.product_price} {item.product_currency}
            </div>
            <div className="mt-4">
                <div className="bg-gray-100 p-3 rounded-lg flex items-center justify-between">
                    <span className="text-lg font-bold">
                        {item.product_currency} {(item.product_price * quantity).toFixed(2)}
                    </span>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={decreaseQty}
                            className="text-gray-400 text-xl px-2 hover:text-black"
                        >
                            -
                        </button>
                        <span>{quantity}</span>
                        <button
                            onClick={increaseQty}
                            className="text-gray-400 text-xl px-2 hover:text-black"
                        >
                            +
                        </button>
                    </div>
                </div>
            </div>
            <button
                onClick={handleAddToCart}
                className="bg-teal-600 text-white w-full mt-4 py-3 rounded-lg font-medium hover:bg-teal-700 transition"
            >
                Add To Cart
            </button>
        </section>
    );
}